var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18",
    "data-name": "Group 18",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.496,
    height: 24.734,
    viewBox: "0 0 29.496 24.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 29.496,
    height: 24.734,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M129.308,147.071h-1.079a2.572,2.572,0,0,1-2.765-2.319v-7.729a2.145,2.145,0,0,1,.81-1.639,3.056,3.056,0,0,1,1.955-.679h12.9a3.057,3.057,0,0,1,1.956.679,2.147,2.147,0,0,1,.809,1.639v.773H145a5.121,5.121,0,0,1,3.179,1.066l2.239,1.789a2.139,2.139,0,0,1,.85,1.664V145.7a1.524,1.524,0,0,1-1.639,1.374h-2.206a2.972,2.972,0,0,1-5.215,0h-7.689a2.972,2.972,0,0,1-5.215,0Zm2.608-1.546a.785.785,0,1,1-.922.773A.858.858,0,0,1,131.915,145.525Zm12.9,0a.785.785,0,1,1-.922.773A.858.858,0,0,1,144.819,145.525Zm-5.53-4.638h-9.217a.785.785,0,1,0,0,1.546h9.217a.785.785,0,1,0,0-1.546Zm0-2.319h-7.374a.785.785,0,1,0,0,1.546h7.374a.785.785,0,1,0,0-1.546Z",
    transform: "translate(-123.62 -129.293)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.ccd51b377c8f1615ea65ec24ed17c0d7.svg";
export { ForwardRef as ReactComponent };